/* eslint-disable no-use-before-define */
import { Country, getCountriesAvailable } from '@nemuru-eng/js-api-client';

const TOP_COUNTRIES_ISO2 = ['ES', 'FR', 'GB', 'MX'];

export const getDialCodeList = (availableCountriesIso2?: string[]): Country[] => {
  // list only available countries
  if (availableCountriesIso2 && availableCountriesIso2.length > 0) {
    return getSortedCountriesDialCodeList(availableCountriesIso2);
  }

  // list all countries (TOP + OTHER)
  const countriesTop = getSortedCountriesDialCodeList(TOP_COUNTRIES_ISO2);
  const countriesOther = getCountriesAvailable()
    .filter((country) => !TOP_COUNTRIES_ISO2.includes(country.iso2))
    .sort((a, b) => parseInt(a.dialCode) - parseInt(b.dialCode));

  return [...countriesTop, ...countriesOther];
};

export const getSortedCountriesDialCodeList = (countriesIso2: string[]): Country[] => {
  return countriesIso2.reduce((acc, currentIso2) => {
    const foundCountry = getCountriesAvailable().find(
      (country) => country.iso2.toLowerCase() === currentIso2.toLowerCase(),
    );
    if (foundCountry) acc.push(foundCountry);
    return acc;
  }, [] as Country[]);
};
